export interface MemoizationState {
	stateSnapshot: any[];
	cachedReturnValue?: any;
}

/**
 * Includes all memoized selectors input snapshots and cached return values
 *
 * Selector.method1 ->
 *        args1 -> { [input1, input2], return1 }
 *        args2 -> { [input1, input2], return2 }
 * Selector.method2 ->
 *        args3 -> { [input3], return3 }
 */
const defaultMemoizeStore = new Map<() => unknown, Record<string, MemoizationState>>();

export function getMemoizationItem(
	key: () => unknown,
	argsKey: string,
	memoizeStore: Map<() => unknown, Record<string, MemoizationState>> | undefined
): MemoizationState {
	if (!memoizeStore) {
		memoizeStore = defaultMemoizeStore;
	}
	const item = memoizeStore.get(key) || {};
	memoizeStore.set(key, item);

	const argsItem = item[argsKey] || { stateSnapshot: [] };
	item[argsKey] = argsItem;

	return argsItem;
}

/**
 * Clears selector input snapshots for Browser Only
 * Useful in unit tests to clean up after each test
 */
export function clearMemoizationStore() {
	defaultMemoizeStore.clear();
}
